export default "__VITE_ASSET__3btKgVFa__"